import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "lotto-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = { id: "lotto-home" }
const _hoisted_3 = { class: "dash-head" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dash-head-text" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "dash-title" }, "로또"),
  /*#__PURE__*/_createElementVNode("p", { class: "dash-sub" }, "최신 당첨 결과와 내 구매 현황을 한눈에.")
], -1)
const _hoisted_5 = { class: "dash-top" }
const _hoisted_6 = { class: "dash-card result-card" }
const _hoisted_7 = { class: "rc-head" }
const _hoisted_8 = { class: "rc-nav" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "rc-round" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "rc-date"
}
const _hoisted_13 = {
  key: 0,
  class: "rc-balls"
}
const _hoisted_14 = { class: "number" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "rc-plus" }, "+", -1)
const _hoisted_16 = { class: "number" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "rc-bonus-label" }, "마지막은 보너스 번호", -1)
const _hoisted_18 = {
  key: 1,
  class: "rc-prize-row"
}
const _hoisted_19 = { class: "rc-prize" }
const _hoisted_20 = { class: "rc-prize-v accent" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "rc-prize-l" }, "1등 1인 당첨금", -1)
const _hoisted_22 = { class: "rc-prize" }
const _hoisted_23 = { class: "rc-prize-v" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "rc-prize-l" }, "1등 당첨자", -1)
const _hoisted_25 = { class: "rc-prize" }
const _hoisted_26 = { class: "rc-prize-v" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "rc-prize-l" }, "총 판매금액", -1)
const _hoisted_28 = { class: "dash-card summary-card" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "sc-title" }, "내 로또 요약", -1)
const _hoisted_30 = { class: "sc-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "sc-l" }, "누적 구매", -1)
const _hoisted_32 = { class: "sc-v" }
const _hoisted_33 = { class: "sc-row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "sc-l" }, "누적 당첨금", -1)
const _hoisted_35 = { class: "sc-v accent" }
const _hoisted_36 = { class: "sc-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "sc-l" }, "이번 주 구매", -1)
const _hoisted_38 = { class: "sc-v" }
const _hoisted_39 = { class: "sc-row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "sc-l" }, "최고 등수", -1)
const _hoisted_41 = { class: "sc-v" }
const _hoisted_42 = {
  key: 1,
  class: "sc-empty"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, "로그인하면 내 구매·당첨 현황을 볼 수 있어요.", -1)
const _hoisted_44 = { class: "dash-hall" }
const _hoisted_45 = { class: "dash-card hall-card" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "hc-title" }, "브리저 최근 당첨", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "hc-desc" }, "브리저에서 만들어 구매한 번호 중 최근 당첨된 내역이에요.", -1)
const _hoisted_48 = {
  key: 0,
  class: "hall-list"
}
const _hoisted_49 = { class: "hall-balls" }
const _hoisted_50 = { class: "hall-meta" }
const _hoisted_51 = {
  key: 1,
  class: "hall-empty"
}
const _hoisted_52 = { class: "dash-card hall-card" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "hc-title" }, "역대 최고 등수", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "hc-desc" }, "브리저 이용자들이 기록한 역대 최고 순위예요.", -1)
const _hoisted_55 = {
  key: 0,
  class: "hall-list"
}
const _hoisted_56 = { class: "hall-balls" }
const _hoisted_57 = { class: "hall-meta" }
const _hoisted_58 = {
  key: 1,
  class: "hall-empty"
}
const _hoisted_59 = {
  key: 0,
  class: "dash-week"
}
const _hoisted_60 = { class: "dw-head" }
const _hoisted_61 = { class: "dw-title" }
const _hoisted_62 = {
  key: 0,
  class: "dw-meta"
}
const _hoisted_63 = {
  key: 0,
  class: "dw-legend"
}
const _hoisted_64 = {
  key: 0,
  class: "dw-list"
}
const _hoisted_65 = {
  key: 1,
  class: "dw-empty"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "dw-empty-icon" }, "🎱", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", null, "이번 주 구매한 번호가 없어요.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LottoBuyGame = _resolveComponent("LottoBuyGame")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          class: "dash-cta",
          to: "/lotto/generate"
        }, {
          default: _withCtx(() => [
            _createTextVNode("+ 번호 생성하기")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "rc-arrow",
                disabled: _ctx.result.drwNo <= 1,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevDrw && _ctx.prevDrw(...args))),
                "aria-label": "이전 회차"
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode("제 "),
                _createElementVNode("b", null, _toDisplayString(_ctx.result.drwNo || '-'), 1),
                _createTextVNode("회")
              ]),
              _createElementVNode("button", {
                class: "rc-arrow next",
                disabled: _ctx.result.drwNo >= _ctx.lastDrwNo,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextDrw && _ctx.nextDrw(...args))),
                "aria-label": "다음 회차"
              }, null, 8, _hoisted_11)
            ]),
            (_ctx.result.drwNoDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.result.drwNoDate)) + " 추첨", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.result.drwNo > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.winNumbers, (num, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'rc-' + i,
                    class: _normalizeClass(["lotto-ball", _ctx.getColorClass(num)])
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(num), 1)
                  ], 2))
                }), 128)),
                _hoisted_15,
                _createElementVNode("div", {
                  class: _normalizeClass(["lotto-ball", _ctx.getColorClass(_ctx.result.bnusNo)])
                }, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.result.bnusNo), 1)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _hoisted_17,
          (_ctx.result.drwNo > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.getMoneyFormat(_ctx.result.firstWinamnt)) + "원", 1),
                  _hoisted_21
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.getMoneyFormat(_ctx.result.firstPrzwnerCo)) + "명", 1),
                  _hoisted_24
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getShortenMoney(_ctx.result.totSellamnt)), 1),
                  _hoisted_27
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            class: "rc-more",
            to: { path: '/lotto/result', query: { drwNo: _ctx.result.drwNo } }
          }, {
            default: _withCtx(() => [
              _createTextVNode("당첨 결과 자세히 →")
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          (_ctx.isLogin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.getMoneyFormat(_ctx.myStats.totalGames)) + " 게임", 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.getMoneyFormat(_ctx.myStats.totalPrize)) + "원", 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.progressList.length) + " 게임", 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.myStats.bestRank <= 5 ? _ctx.myStats.bestRank + '등' : '-'), 1)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("button", {
                  class: "sc-login-btn",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goLogin && _ctx.goLogin(...args)))
                }, "로그인")
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _hoisted_47,
          (_ctx.recentWins.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentWins, (g, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'rw-' + idx,
                    class: "hall-item"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["hall-rank", 'rank-' + g.rank])
                    }, _toDisplayString(g.rank) + "등", 3),
                    _createElementVNode("div", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameNumbers(g), (num, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'rwb-' + idx + '-' + i,
                          class: _normalizeClass(["hall-ball", _ctx.getColorClass(num)])
                        }, _toDisplayString(num), 3))
                      }), 128))
                    ]),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(g.drwNo) + "회 · " + _toDisplayString(g.nickname || '익명'), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_51, "아직 당첨 내역이 없어요."))
        ]),
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _hoisted_54,
          (_ctx.bestWins.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bestWins, (g, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'bw-' + idx,
                    class: "hall-item"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["hall-rank", 'rank-' + g.rank])
                    }, _toDisplayString(g.rank) + "등", 3),
                    _createElementVNode("div", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameNumbers(g), (num, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'bwb-' + idx + '-' + i,
                          class: _normalizeClass(["hall-ball", _ctx.getColorClass(num)])
                        }, _toDisplayString(num), 3))
                      }), 128))
                    ]),
                    _createElementVNode("span", _hoisted_57, _toDisplayString(g.drwNo) + "회 · " + _toDisplayString(g.nickname || '익명'), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_58, "아직 기록이 없어요."))
        ])
      ]),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("h2", _hoisted_61, [
                _createTextVNode(" 이번 주 내 구매 "),
                (_ctx.progressDrwNo > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, "· 제 " + _toDisplayString(_ctx.progressDrwNo) + "회 (추첨 전)", 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.progressList.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_63, "유형별로 색이 구분돼요"))
                : _createCommentVNode("", true)
            ]),
            (_ctx.progressList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progressList, (game, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'dw-' + idx,
                      class: "dw-item"
                    }, [
                      _createVNode(_component_LottoBuyGame, { lottoGame: game }, null, 8, ["lottoGame"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _hoisted_66,
                  _hoisted_67,
                  _createVNode(_component_router_link, {
                    class: "dw-empty-cta",
                    to: "/lotto/generate"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("번호 생성하러 가기")
                    ]),
                    _: 1
                  })
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}